<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" class="eb-icon">
    <g>
      <path
        d="M35,17.5C35,27.162,27.161,35,17.5,35S0,27.162,0,17.5S7.839,0,17.5,0S35,7.838,35,17.5z"
      />
      <path
        fill="#FFFFFF"
        d="M26.979,17.5c0-0.523-0.273-1.003-0.729-1.254L13.854,8.955c-0.434-0.273-1.003-0.273-1.459-0.022
		c-0.455,0.273-0.729,0.752-0.729,1.276v14.582c0,0.523,0.273,1.003,0.729,1.275c0.229,0.115,0.479,0.184,0.729,0.184
		s0.501-0.068,0.729-0.206l12.396-7.291C26.706,18.502,26.979,18.023,26.979,17.5z"
      />
    </g>
  </svg>
</template>
